import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import * as moment from 'moment';
import { sortBy } from 'lodash';
import Loading from 'components/Loading';
import DateFormats from 'constants/DateFormats';
import styles from './ParticipationInOrganizations.module.scss';
import InfoBlock from './InfoBlock';
import Tooltip from '../../../../components/Tooltip';

const ROLE_HEAD = 'HEAD';
const ROLE_FOUNDER_DESCRIPTION = 'Учредитель (участник)';
const ROLE_HEAD_DESCRIPTION = 'Руководитель';

const UNRELIABILITY_CONTENT = (
  <p className={styles.tooltipText}>
    Согласно сведениям, содержащимся в ЕГРЮЛ, в отношении данной организации присутствует запись о
    недостоверности сведений о руководителе и (или) учредителе (участнике).{' '}
    <a href={'https://www.nalog.ru/rn77/ukep_opasnost/'} target={'_blank'}>
      Подробнее
    </a>
    .
  </p>
);

class ParticipationInOrganizations extends Component {
  componentDidMount() {
    const { getParticipation } = this.props;
    getParticipation();
  }

  getParticipation() {
    const { data } = this.props;
    const participations = data.get('data');
    return participations
      ? participations.reduce(
          ([pass, fail], elem) =>
            elem.statusOrg !== ROLE_HEAD ? [[...pass, elem], fail] : [pass, [...fail, elem]],
          [[], []],
        )
      : [];
  }

  sortItems(items) {
    return sortBy(items, ['-dateFrom', 'orgNaim']);
  }

  renderTable(header, participations) {
    return (
      <table className={styles.table}>
        <thead>
          <tr>
            <td colSpan={4} className={styles.subHeader}>
              <h3 className={styles.roleHeader}>{header}</h3>
            </td>
          </tr>
        </thead>
        <tbody>
          {!!participations.length &&
            participations.map(({ orgNaim, orgInn, orgKpp, orgOgrn, dateFrom, reliable }, key) => (
              <tr key={key}>
                <td className={styles.fieldName}>{orgNaim}</td>
                <td className={styles.fieldOrgn}>{orgOgrn}</td>
                <td className={styles.fieldInn}>
                  {orgInn} / {orgKpp}
                </td>
                <td className={styles.fieldDate}>{moment(dateFrom).format(DateFormats.long)}</td>

                <td>
                  {reliable === false && (
                    <Tooltip
                      hasWrapper={false}
                      customIcon={'icon_attention'}
                      isFormClass={false}
                      content={UNRELIABILITY_CONTENT}
                    />
                  )}
                </td>
              </tr>
            ))}
          {!participations.length && (
            <tr>
              <td colSpan={4}>Нет сведений</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  renderInfoBlock() {
    return (
      <InfoBlock title={'Информация'}>
        <div className={styles.infoText}>
          <p>
            На данной странице представлены сведения об организациях, в которых Вы являетесь
            руководителем или учредителем (участником).
          </p>
          <p>
            В случае неправомерной регистрации юридического лица с использованием Ваших данных Вы
            можете ознакомиться с необходимыми действиями на{' '}
            <a
              href={'https://www.nalog.ru/rn77/ukep_opasnost/#lk'}
              target={'_blank'}
              className={styles.infoLink}
            >
              сайте ФНС.
            </a>
          </p>
        </div>
      </InfoBlock>
    );
  }

  renderContent() {
    const [participationsAsFounder = [], participationsAsHead = []] = this.getParticipation();

    return (
      <div className={'white-block__pad40 pt-0'}>
        {this.renderInfoBlock()}
        <table className={styles.table}>
          <thead>
            <tr className={styles.header}>
              <th className={styles.fieldName}>Наименование организации</th>
              <th className={styles.fieldOrgn}>ОГРН</th>
              <th className={styles.fieldInn}>ИНН / КПП</th>
              <th className={styles.fieldDate}>Дата сведений</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={4}>
                {this.renderTable(ROLE_HEAD_DESCRIPTION, this.sortItems(participationsAsHead))}
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                {this.renderTable(
                  ROLE_FOUNDER_DESCRIPTION,
                  this.sortItems(participationsAsFounder),
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { data } = this.props;
    const isLoading = data.get('loading');

    return (
      <div className={styles.participations}>
        {isLoading && <Loading />}
        {!isLoading && this.renderContent()}
      </div>
    );
  }
}

ParticipationInOrganizations.propTypes = {
  data: PropTypes.instanceOf(Map),
  getParticipation: PropTypes.func,
};

export default ParticipationInOrganizations;
